import defineProperty from './_define_property';
defineProperty(Array, 'insert', function (index, item) {
  return this.splice(index, 0, item);
});